import React, {Component, Fragment} from "react";
import PropTypes from "prop-types";

/**
 * A hello world component. A very reusable component
 */
class HelloWorld extends Component {
	constructor(props) {
		super(props);
		this.state = {}
	}

	static defaultProps = {
		message: "World",
		user: {
			name : "",
			age: ""
		}
	};

	render() {
		return (
			<Fragment>
				Hello {this.props.message}
			</Fragment>
		);
	}
}

HelloWorld.propTypes = {
	/** Message to display */
	message: PropTypes.string,
	/** Optional user object */
	user : PropTypes.shape({
		name: PropTypes.string,
		age: PropTypes.number
	})
};

HelloWorld.defaultProps = {
	message: "World",
	user: {
		name : "",
		age: ""
	}
};


export default HelloWorld;
